import cn from 'classnames'
import React from 'react'

// import { createGlobalStyle } from 'styled-components';

// createGlobalStyle`
//   .com-dropdown-item {
//    border-top: 1px solid $gray;
//   padding: 7px 10px;

//     &:first-child {
//       border-top: none;
//     }

//     &:hover {
//       background-color: $lightgray;
//     }
//   }
// `;

const DropdownItem = props => {
  const { className, onClick, component, children, ...rest } = props

  const option = {
    className: cn('com-dropdown-item', className),
    onClick,
    ...rest,
  }

  return React.createElement(component, { ...option }, children)
}

DropdownItem.defaultProps = {
  component: 'li',
  className: '',
  onClick: f => f,
}

export default DropdownItem
